import { useRef, useState, useCallback, useEffect } from 'react';
import Webcam from 'react-webcam';
import classes from './index.module.scss';
import Draggable from 'react-draggable';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useMediapipeProctoring } from '../../../../hooks/useMediapipeProctoring';
import { useLocation, useParams } from 'react-router-dom';

interface cameraComponentProps {
  cameraRef: any;
  onLoad: () => void;
}

const CameraComponent = ({ cameraRef, onLoad }: cameraComponentProps) => {
  const location = useLocation();
  const accessKey = location.pathname.slice(1);
  const webcamRef = cameraRef;
  const [videoElement, setVideoElement] = useState<HTMLVideoElement | null>(
    null
  );
  const [cameraAvailable, setCameraAvailable] = useState(false);
  useEffect(() => {
    if (webcamRef.current?.video) {
      setVideoElement(webcamRef.current.video);
    }
  }, [cameraAvailable]); // set this when onUserMedia is called
  const events = useMediapipeProctoring({
    accessKey: accessKey,
    videoRef: { current: videoElement }, // 👈 important: wrap in a ref-like object
  });

  const dragRef = useRef(null);

  const [open, setOpen] = useState(true);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const videoConstraints = {
    aspectRatio: 1,
    width: 400,
    height: 400,
    facingMode: 'user',
  };

  const handleLoad = () => {
    setCameraAvailable(true);
    setTimeout(onLoad, 2000);
  };

  return (
    <Draggable nodeRef={dragRef}>
      <div
        ref={dragRef}
        className={classes.container}
        style={{ height: open ? '16rem' : 'auto' }}
      >
        <div className={classes.infoContainer}>
          <p>Candidate</p>
          <div className={classes.centeredFlex} onClick={handleToggle}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </div>
        </div>
        <div className={open ? classes.openVideo : classes.closeVideo}>
          <Webcam
            // forceScreenshotSourceSize
            onUserMedia={handleLoad}
            ref={webcamRef}
            onUserMediaError={(err) => {
              setCameraAvailable(false);
              console.error('Failed to receive user media stream:', err);
            }}
            screenshotFormat="image/jpeg"
            mirrored
            videoConstraints={videoConstraints}
            screenshotQuality={1}
            minScreenshotHeight={400}
            minScreenshotWidth={400}
            style={
              open
                ? {
                    flex: '1 1 1px',
                    maxHeight: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    objectFit: 'cover',
                  }
                : {}
            }
          />
        </div>
      </div>
    </Draggable>
  );
};

export default CameraComponent;
